import { VisualComponent } from "./visual/visual.component";

export const QuickSightComponents = [
    VisualComponent
]